export class dynamicschemaData {
public fields: any[] = [
    {
      type: 'text',
      name: 'firstName',
      label: 'First Name',
    value: 'John',
    forbiddenNameValidator: true,
      required: true,
  },
  {
    type: 'text',
    name: 'middleName',
    label: 'Middle Name',
    value: '',
    required: false,
   },
    {
      type: 'text',
      name: 'lastName',
      label: 'Last Name',
      value: '',
      required: true,
      maxLength: '2'
    },
    {
      type: 'text',
      name: 'email',
      label: 'Email',
      value: '',
      required: true,
    },
  { type: 'date', name: 'DOB', label: 'DOB', value: '11/21/2011', placeholder: 'MM/dd/yyyy', required: true },
    // {
    //  type: 'file',
    //  name: 'picture',
    //  label: 'Picture',
    //  required: false
    // },
    {
      type: 'dropdown',
      name: 'country',
      label: 'Country',
      value: 'in',
      required: true,
      options: [
        { key: 'in', label: 'India' },
        { key: 'us', label: 'USA' }
      ]
    },
    {
      type: 'radio',
      name: 'gender',
      label: 'Gender',
      value: 'in',
      required: false,
      options: [
        {name: 'g', key: 'm', label: 'Male' },
        { name: 'g', key: 'f', label: 'Female' }
      ]
    },
    {
      type: 'checkbox',
      name: 'hobby',
      label: 'Hobby',
      required: false,
      options: [
        { key: 'f', label: 'Fishing' },
        { key: 'c', label: 'Cooking' }
      ]
    }
  ];
}
